import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
    build.mutation<void, string>({
        query: (id) => ({
            url: `${APP_ENDPOINTS.COMPANY}/${id}`,
            method: 'DELETE',
        }),
        invalidatesTags: [
            { type: 'companies-with-join', id: 'GET-JOIN' },
            { type: 'companies', id: 'GET' },
        ],
    });
